"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.d3 = d3;
exports.d6 = d6;
exports.d8 = d8;
exports.getRandomItem = getRandomItem;
exports.getRandomNumber = getRandomNumber;
exports.shuffleArray = shuffleArray;
const rollDice = (quantity, max) => {
    let total = 0;
    for (let i = 0; i < quantity; ++i) {
        total += getRandomNumber.call(this, 1, max);
    }
    return total;
};
function shuffleArray(array) {
    return [...array].sort(() => 0.5 - Math.random());
}
function getRandomItem(arr) {
    const randomIndex = Math.floor(Math.random() * arr.length);
    const item = arr[randomIndex];
    return item;
}
function getRandomNumber(min, max, r = Math.random) {
    return Math.floor(r() * (max - min + 1)) + min;
}
function d8(quantity = 1, max = 8) {
    return rollDice(quantity, max);
}
function d6(quantity = 1, max = 6) {
    return rollDice(quantity, max);
}
function d3(quantity = 1, max = 3) {
    return rollDice(quantity, max);
}
